import { z } from 'zod';
import {
  lngUnitLabels,
  serviceTypesFilterLabels,
  serviceTypeValues,
} from 'src/apis/lng-marketing/mappings';
import type { LngGeneralUnit, ServiceType } from 'src/apis/lng-marketing/types';
import {
  descSortDirectionSchema,
  formOptionSchema,
} from 'src/components/form/zod-schemas';
import { preprocessAsArray } from 'src/components/form/zod-utilities';

export const commonAllocationsSchema = z.object({
  sortDirection: descSortDirectionSchema,
  offerName: z.string().nullable().default(null),
  serviceRuntimeStart: z.string().nullable().default(null),
  serviceRuntimeEnd: z.string().nullable().default(null),
  availableServices: z.preprocess(
    preprocessAsArray,
    z.array(z.enum(serviceTypeValues)).default([])
  ),
  terminalId: z.preprocess(
    preprocessAsArray,
    z.array(formOptionSchema).default([])
  ),
  lngDealId: z
    .string()
    .regex(/^(LNGD-\d+)$/, '{label} must start from "LNGD-".')
    .nullable()
    .default(null),
  mwhPriceMin: z.coerce.number().nullable().default(null),
  mwhPriceMax: z.coerce.number().nullable().default(null),
  gasAmountMin: z.coerce.number().nullable().default(null),
  gasAmountMax: z.coerce.number().nullable().default(null),
});

export const allocationsCommonFilters = {
  offerName: { label: 'Offer Name' },
  availableServices: { label: 'Available Services' },
  serviceRuntimeStart: { label: 'Service Runtime' },
  serviceRuntimeEnd: { label: 'Service Runtime' },
  terminalId: { label: 'Terminal' },
  lngDealId: { label: 'Deal ID' },
  gasAmountMin: { label: 'Gas Amount' },
  gasAmountMax: { label: 'Gas Amount' },
  mwhPriceMin: { label: 'Price / MWh' },
  mwhPriceMax: { label: 'Price / MWh' },
};

export const getPriceContent = (
  priceCalculatedFromSlotDuration: boolean,
  serviceUsedForPriceCalculation?: ServiceType | null
) => {
  if (priceCalculatedFromSlotDuration && !serviceUsedForPriceCalculation) {
    return (
      <>
        The price was calculated from the given slot duration, please refer to
        the details.
      </>
    );
  }

  if (priceCalculatedFromSlotDuration && !!serviceUsedForPriceCalculation) {
    return (
      <>
        The price was calculated from the given slot duration, please refer to
        the details. <br />
        <br />
        <strong>
          {serviceTypesFilterLabels[serviceUsedForPriceCalculation]}
        </strong>{' '}
        was used for price calculation.
      </>
    );
  }

  return (
    <>
      <strong>
        {serviceTypesFilterLabels[serviceUsedForPriceCalculation!]}
      </strong>{' '}
      was used for price calculation.
    </>
  );
};

export function getUnitLabel(unit: LngGeneralUnit): string {
  return `/${lngUnitLabels[unit]}`;
}
